import { render, staticRenderFns } from "./raisedFreightAndVendorApproval.vue?vue&type=template&id=dbbb2d9a&scoped=true"
import script from "./raisedFreightAndVendorApproval.vue?vue&type=script&lang=js"
export * from "./raisedFreightAndVendorApproval.vue?vue&type=script&lang=js"
import style0 from "./raisedFreightAndVendorApproval.vue?vue&type=style&index=0&id=dbbb2d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb2d9a",
  null
  
)

export default component.exports